"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSocialMediaIcon = exports.findPersonById = void 0;
var _facebook = _interopRequireDefault(require("../../assets/images/facebook.png"));
var _twitter = _interopRequireDefault(require("../../assets/images/twitter.png"));
var _linkedin = _interopRequireDefault(require("../../assets/images/linkedin.png"));
var _other = _interopRequireDefault(require("../../assets/images/other.png"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const findPersonById = (people, id) => {
  const person = people.filter(item => {
    return item.speakerId === id;
  })[0];
  if (!person) {
    throw new Error('No required data');
  }
  return person;
};
exports.findPersonById = findPersonById;
const getSocialMediaIcon = key => {
  switch (key.toLowerCase()) {
    case 'facebook':
      return _facebook.default;
    case 'twitter':
      return _twitter.default;
    case 'linkedin':
      return _linkedin.default;
    default:
      return _other.default;
  }
};
exports.getSocialMediaIcon = getSocialMediaIcon;